import { Card, CardHeader, Stack } from "@mui/material";
import  { useEffect, useState } from "react";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import _ from "lodash";
import Swal from "sweetalert2";
import {
  allProducts,
  deleteProduct,
  exportProductMaster,
  uploadProductMaster,
} from "./productData";
import URL from "../../../pages/Utils/url";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import { useMutation } from "@apollo/client";
import { useLoading } from "../../../context/LodingContext";
import { downloadExcelFile } from "../../function/downloadExcel";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import RoleAccess from "../../function/RoleAccess";
import { showUploadDialog } from "../../../components/uploadDialog/ExcelUploadDialog";
import { FileUploadModal } from "../../../components/uploadDialog/FileUploadModal";
import TableComponents from "../../../../src/components/tabel/index";
import * as XLSX from "xlsx";

const ProductMaster = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [UpdateFile] = useMutation(uploadProductMaster);
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const { userId } = useAuthData();
  const [uploadStatus, setUploadStatus] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [dataCount, setDataCount] = useState({
    pageCount: 0,
    itemCount: 0,
  });

  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    fetchdata();
  }, [pagination, searchValue]);

  const ProductMasterListTable = {
    columns: [
      {
        header: "Product Code",
        accessorKey: "productCode",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Product Name",
        accessorKey: "productName",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Product Category",
        accessorKey: "productCategory",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Product Brand",
        accessorKey: "productBrand",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Create By",
        accessorKey: "createdBy",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Create Date",
        accessorKey: "createdAt",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Action",
        accessorKey: "Action",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
    ],
    rows: data.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      productCode: v?.productCode,
      productName: _.capitalize(v?.productName),
      productCategory: _.capitalize(v?.productCategory),
      productBrand: _.capitalize(v?.productBrand),
      createdBy: v?.user?.employeeName,
      createdAt: v?.createdAt?.slice(0, 10),

      Action: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <RoleAccess
            modelName="Product Master Screen"
            component="ViewProductMaster"
          >
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/product-masters/view-product-master`, {
                  state: { type: "view", data: v, rowId: v?.id },
                })
              }
            />
          </RoleAccess>

          <RoleAccess
            modelName="Product Master Screen"
            component="UpdateProductMaster"
          >
            <EditIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/product-masters/edit-product-master`, {
                  state: { type: "edit", data: v, rowId: v?.id },
                })
              }
            />
          </RoleAccess>

          <DeleteIcon
            fontSize="small"
            className="actionIcon"
            onClick={() => handleDelte(v?.id)}
          />
        </div>
      ),
    })),
  };

  const fetchdata = async (searchText = "") => {
    setIsLoading(true);

    try {
      const res = await request(BASEURL, allProducts, {
        page: pagination.pageIndex + 1,
        pageSize: pagination.pageSize,
        search: searchValue,
      });

      const success = res?.allProducts?.success;
      const message = res?.allProducts?.message;

      if (success) {
        let newdata = res?.allProducts?.data || [];

        if (searchText !== "") {
          newdata = newdata.filter((item) =>
            item?.productName?.toLowerCase().includes(searchText.toLowerCase())
          );
        }

        newdata = newdata.map((val) => ({
          ...val,
          productImage: val?.productImage
            ? `${URL}media/${val.productImage}`
            : null,
        }));

        setData(newdata);

        setDataCount({
          itemCount: res?.allProducts?.totalCount,
          pageCount: res?.allProducts?.totalPages,
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });

        setData([]);
        setDataCount({ itemCount: 0, pageCount: 0 });
      }
    } catch (err) {
      const message =
        err?.response?.errors?.message ||
        err?.message ||
        "Something went wrong";

      Swal.fire({
        position: "top",
        icon: "error",
        title: message,
        showConfirmButton: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleExcelUpload = async (file) => {
    setUploadStatus(false);
    setCirleLoading(true);
    try {
      const response = await UpdateFile({
        variables: {
          file: file,
          userId: userId,
        },
        context: { hasUpload: true },
      });

      const res = response?.data?.uploadProductMaster?.success;
      const message = response?.data?.uploadProductMaster?.message;

      if (res) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          fetchdata();
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "File upload failed!",
        text: error.message,
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const handleDownload = () => {
    setCirleLoading(true);
    request(BASEURL, exportProductMaster).then(async (res) => {
      const status = res?.exportProductMaster?.success;
      const message = res?.exportProductMaster?.message;

      const pdfurl = `${URL}${res?.exportProductMaster?.fileUrl?.slice(1)}`;

      if (status) {
        const status = await downloadExcelFile(pdfurl, "Product_Master.xlsx");
        setCirleLoading(false);
      } else {
        setCirleLoading(false);
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,

          showConfirmButton: true,
        });
      }
    });
  };

  const handleDelte = (id) => {
    Swal.fire({
      title: "Are you sure you want to delete this data?",
      text: "This action is irreversible and cannot be recovered.",
      icon: "question",
      showCancelButton: true,
    }).then(async (result) => {
      if (result?.isConfirmed) {
        setCirleLoading(true);
        try {
          const res = await request(BASEURL, deleteProduct, {
            id: id,
          });

          const success = res?.deleteProduct?.success;
          const message = res?.deleteProduct?.message;
          if (success) {
            Swal.fire({
              position: "top",
              icon: "success",
              title: message,
              showConfirmButton: true,
            }).then(() => {
              fetchdata();
            });
          } else {
            Swal.fire({
              position: "top",
              icon: "error",
              title: message,
              showConfirmButton: true,
            });
          }
        } catch (err) {
        } finally {
          setCirleLoading(false);
        }
      }
    });
  };

  const handleSampleExcelDownload = () => {
    const headers = [
      [
        "BRANDCODE",
        "CATEGORYCODE",
        "ITEMCODE",
        "ITEMNAME",
        "ITEMBRAND",
        "LEASTUOM",
        "UOM",
        "CONVERSION",
        "VAT",
        "BAS",
        "COD",
        "CSH",
        "SMT",
        "VANSL",
      ],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(headers);
    worksheet["!cols"] = [
      { wch: 14 },
      { wch: 16 },
      { wch: 14 },
      { wch: 22 },
      { wch: 16 },
      { wch: 14 },
      { wch: 12 },
      { wch: 14 },
      { wch: 10 },
      { wch: 10 },
      { wch: 10 },
      { wch: 10 },
      { wch: 10 },
      { wch: 12 },
    ];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Product_Master_Sample");
    XLSX.writeFile(workbook, "Product_Master_Sample.xlsx");

    Swal.fire({
      position: "top",
      icon: "success",
      title: "Sample Excel Downloaded Successfully",
      showConfirmButton: true,
    });
  };

  const handleUploadClick = () => {
    setUploadStatus(false);
    setTimeout(() => setUploadStatus(true), 0);
  };

  const handleSearch = (searchValue) => {
    setSearchValue(searchValue);
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Product Master List
                </MaterialTypography>
              </Stack>
              <RoleAccess
                modelName="Product Master Screen"
                component="ExportProductMaster"
              >
                {data?.length > 0 && (
                  <button
                    className="container-btn-file"
                    onClick={handleDownload}
                    style={{
                      height: "38px",
                      marginLeft: "0",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    <svg
                      fill="#fff"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 50 50"
                    >
                      <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                    </svg>
                    Export File
                  </button>
                )}
              </RoleAccess>
              <button
                className="container-btn-file"
                style={{
                  height: "38px",
                  marginLeft: "0",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
                onClick={handleSampleExcelDownload}
              >
                <svg
                  fill="#fff"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 50 50"
                >
                  <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                </svg>
                Sample Excel
              </button>
              <RoleAccess
                modelName="Product Master Screen"
                component="UploadProductMaster"
              >
                <label
                  className="container-btn-file"
                  style={{
                    height: "38px",
                    marginLeft: "0",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  onClick={() => handleUploadClick()}
                >
                  <svg
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                  </svg>
                  Upload File
                </label>
              </RoleAccess>

              {/* <RoleAccess
                modelName="Product Master Screen"
                component="CreateProductMaster"
              > */}
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() =>
                  navigate("/product-masters/add-product-master", {
                    state: { type: "add" },
                  })
                }
              >
                Product Master
              </MaterialButton>
              {/* </RoleAccess> */}
            </Stack>
          }
        />
        {uploadStatus && (
          <FileUploadModal
            key={Date.now()} // force remount
            status={uploadStatus}
            onClose={() => setUploadStatus(false)}
            onSubmit={(file) => handleExcelUpload(file)}
            onDownloadSample={handleSampleExcelDownload}
          />
        )}

        <>
          <TableComponents
            rows={ProductMasterListTable?.rows}
            columns={ProductMasterListTable?.columns}
            pagination={pagination}
            setPagination={setPagination}
            pageCount={dataCount.pageCount}
            onChange={handleSearch}
            recordCount={dataCount.itemCount}
            isLoading={isLoading}
            isSearch={true}
          />
        </>
      </Card>
    </DashboardLayout>
  );
};

export default ProductMaster;
